<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData"></UPDATE>
    <UPDATE ref="childUpdate1" :updateData="updateData1"></UPDATE>
    <RELATIONOPENURL ref="relationOpenUrl"></RELATIONOPENURL>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    import RELATIONOPENURL from '@/views/newmis36/customerRelation/relationOpenUrl.vue'
    import Qs from 'qs'
    //接口地址url的统一管理
    import URL from '@/views/newmis36/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import download from '@/utils/download'
    let matchType = {"0": "有推荐人", "1": "匹配", "2": "不匹配", "3": "无推荐人"};
    let activeStatus = {"1": "已激活", "0": "未激活"};
    let levelType = {"MIN":"迷你","STD":"标准","PLA":"铂金"};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE,
            RELATIONOPENURL
        },
        methods: {
            checkbox(row) {
                this.deleteIds = row.map(key => key.id).join(",");
            },
            /*表格按钮点击事件*/
            bthClick(clickName, row) {
                if (clickName == "update") {
                    this.$refs.childUpdate.open(row);
                }else if(clickName == "relationCount"){
                    //推荐人数展示
                    this.$refs.childUpdate1.open(this.relationCountList[row.directNumber] || {});
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data) {
                if ("查询" == clickName || window.$t('txmis.bt.query') == clickName) {
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                } else if (window.$t('txmis.bt.add') == clickName) {
                    this.$refs.childUpdate.open();
                } else if (window.$t('txmis.bt.down') == clickName) {
                    //隐藏关键字段
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide: true});
                    download.exportExcel(URL.customerRelation.downloadList, param, window.$t('txmis.relationList.customerRelation'));
                } else if (window.$t('txmis.bt.export') == clickName) {
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {});
                    download.exportExcel(URL.customerRelation.downloadList, param, window.$t('txmis.relationList.customerRelation'));
                }else if (clickName == window.$t('txmis.relationList.relationOpenUrl')) {
                    this.$refs.relationOpenUrl.open();
                }
            },
            /*新增或跟提交数据触发事件*/
            submit(model) {
                //根据是否包含id更新还是添加
                this.dataChanage(URL.customerRelation.edit, model, res => {
                    if (res.code == 0) {
                        this.$message.success(window.$t('txmis.rewardDealList.confirmSuccess'));
                        this.$refs.childUpdate.close();
                        this.$refs.childTable.defaultGetData(this.queryData);
                    } else {
                        this.$message.success(window.$t('txmis.rewardDealList.confirmFail'));
                    }
                })
            },
            dataChanage(url, option, suc, fail) {
                this.axios.post(url, Qs.stringify(option || {})).then(res => {

                    if (suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if (fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        mounted(){
            this.axios.get(URL.customerRelation.relationCount).then(res => {
                console.log(res);
                if (res.code == 0 || res.result){
                    for (let i in res.result) {
                        if (!res.result[i].relationCount)  res.result[i].relationCount = 0;
                        if (!res.result[i].relationStandardCount)  res.result[i].relationStandardCount = 0;
                        this.relationCountList[res.result[i].customerNumber] = res.result[i];
                    }
                }
            })
        },
        data() {
            return {
                deleteIds: "",
                relationCountList:{},
                queryData: {},
                /*新增或更新*/
                updateData: {
                    cols: [
                        {title: 'id', field: 'id', hidden: true},
                        {title: window.$t('txmis.relationList.customerNum'), field: 'customerNum', disabled: true},
                        {title: window.$t('txmis.relationList.mobilePhone'), field: 'mobilePhone', disabled: true},
                        {title: window.$t('txmis.relationList.userName'), field: 'userName', disabled: true},
                        {title: window.$t('txmis.relationList.userLevel'), field: 'userLevel', type: 2, optionList: levelType, disabled: true},
                        {title: window.$t('txmis.relationList.createDate'), field: 'createDate', type: 5, disabled: true},
                        {title: window.$t('txmis.relationList.activeTime'), field: 'activeTime', type: 5, disabled: true},
                        {title: window.$t('txmis.relationList.newdirectPhone'), field: 'newdirectPhone', render: (data, full) => {
                               return full.directPhone;
                            }
                        },
                        {title: window.$t('txmis.relationList.remark'), field: 'remark'},
                    ]
                },
                updateData1:{
                    submit: 'hidden',
                    cols: [
                        {title: window.$t('txmis.relationList.customerNum'), field: 'customerNumber', disabled: true},
                        {title: window.$t('txmis.relationList.relationCount'), field: 'relationCount', disabled: true},
                        {title: window.$t('txmis.relationList.relationStandardCount'), field: 'relationStandardCount', disabled: true},
                    ]
                },
                /*from查询表单*/
                formData: {
                    hasLable: true,
                    cols: [
                        {title: window.$t('txmis.relationList.customerNumber'), field: 'customerNum'},
                        {title: window.$t('txmis.relationList.phone'), field: 'phone'},
                        {title: window.$t('txmis.relationList.beginDate'), field: 'beginDate', type: 5},
                        {title: window.$t('txmis.relationList.endDate'), field: 'endDate', type: 5},
                        {title: window.$t('txmis.tracker.activeStartTime'), field: 'activeStartTime',type:5},
                        {title: window.$t('txmis.tracker.activeEndTime'), field: 'activeEndTime',type:5},
                        {title: window.$t('txmis.relationList.userName'), field: 'userName'},
                        {title: window.$t('txmis.relationList.direct'), field: 'direct'},
                        {title: window.$t('txmis.relationList.matchType'), field: 'matchType', type: 2, optionList: matchType},
                        {title: window.$t('txmis.relationList.activeStatus'), field: 'activeStatus', type: 2, optionList: activeStatus},
                        {title: 'dataType', field: 'dataType', data: 0, hidden: true},
                        {click: window.$t('txmis.bt.query')},
                        {click: window.$t('txmis.bt.down')},
                        {click: window.$t('txmis.bt.export')},
                        {click: window.$t('txmis.relationList.relationOpenUrl')}
                    ]
                },
                /*table生成*/
                pageData: {
                    queryUrl: URL.customerRelation.list, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        {title: window.$t('txmis.relationList.customerNumber'), field: 'customerNum'},
                        {title: window.$t('txmis.relationList.demoCustomerNum'), field: 'demoCustomerNum'},
                        {title: window.$t('txmis.relationList.userName'), field: 'userName'},
                        {
                            title: window.$t('txmis.relationList.userLevel'), field: 'userLevel', render: (data, full) => {
                                return levelType[data] || "";
                            }
                        },
                        {title: window.$t('txmis.relationList.mobilePhone'), field: 'mobilePhone'},
                        {
                            title: window.$t('txmis.relationList.createDate'), field: 'createDate', render: (data, full) => {
                                return DateUtil.formatDate(data, "yyyy-MM-dd hh:mm:ss");
                            }
                        },
                        {
                            title: window.$t('txmis.relationList.activeTime'), field: 'activeTime', render: (data, full) => {
                                return DateUtil.formatDate(data, "yyyy-MM-dd hh:mm:ss");
                            }
                        },
                        {
                            title: window.$t('txmis.relationList.activeStatus'), field: 'activeTime', render: (data, full) => {
                                if (full.activeTime > 0) {
                                    return "已激活";
                                } else {
                                    return "未激活";
                                }
                            }
                        },
                        {title: window.$t('txmis.relationList.directNumber'), field: 'directNumber',h5Click: "relationCount"},
                        {title: window.$t('txmis.relationList.directPhone'), field: 'directPhone'},
                        {title: window.$t('txmis.relationList.indirectNumber'), field: 'indirectNumber'},
                        {title: window.$t('txmis.relationList.indirectPhone'), field: 'indirectPhone'},
                        {
                            title: window.$t('txmis.relationList.reStatus'), field: 'reStatus', render: (data, full) => {
                                if(data=="100") {
                                    if (full.directPhone == null || full.directPhone == '') {
                                        return "无推荐人";
                                    } else {
                                        return "<label style='color: red;'>不匹配</label>";
                                    }
                                }
                                if (data == "110" || data == "111") return "<label style='color: green;'>匹配</label>";
                                return data;
                            }
                        },
                        {
                            field: window.$t('txmis.bt.edit'),
                            title: window.$t('txmis.bt.operation'),
                            size: "mini",
                            click: "update",
                            type: "primary",
                            icon: "el-icon-update"
                        }
                    ]
                }
            }
        }
    }
</script>
